// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-container[data-v-d0754dba]{min-height:100vh;padding-bottom:5rem!important}.register[data-v-d0754dba]{margin-top:8rem;grid-gap:1rem;gap:1rem}.register__btn[data-v-d0754dba] .v-btn__content{line-height:1.55}.register__form[data-v-d0754dba]{height:100%;grid-gap:1rem;gap:1rem}.checkbox__label--link[data-v-d0754dba]{display:inline-block}.checkbox__label--link[data-v-d0754dba]:hover{color:var(--v-primary-hover-base)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
